import React, { FC, useState, useEffect } from 'react';
import { Connect, PropsFromRedux } from './NavFoldersContainer';
import styles from './nav_folders.module.scss';
import { useIsMounted } from '../../components/hooks/useIsMounted';
import { NavFoldersDropdown } from './NavFoldersDropdown';
import { NavItemDropdown } from '../components/item/NavItem';

type Props = {
  cancelHover: (display: boolean, dropdown: string) => void;
} & PropsFromRedux;

export const RawNavFolders: FC<Props> = ({ onLoad, cancelHover }) => {
  const [isFoldersStored, setIsFoldersStored] = useState(false);
  const { getIsMounted } = useIsMounted();

  useEffect(() => {
    const loadFolders = async () => {
      try {
        await onLoad();
        if (getIsMounted()) {
          setIsFoldersStored(true);
        }
      } catch (error) {
        throw error;
      }
    };

    loadFolders();
  }, []);

  return (
    <NavItemDropdown className={styles.container}>
      {(isOpen, toggle) => (
        <NavFoldersDropdown
          isOpen={isOpen}
          toggle={toggle}
          isFoldersStored={isFoldersStored}
          cancelHover={cancelHover}
        />
      )}
    </NavItemDropdown>
  );
};

export const NavFolders = Connect(RawNavFolders);
